import { Box } from "@mui/material";
import type * as React from "react";

/**
 * Superscripted footnote marker (e.g. *, †, or ‡). `lineHeight: 0` keeps the
 * raised glyph from pushing surrounding lines apart.
 */
const FootnoteSup: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box component="sup" sx={{ lineHeight: 0, fontSize: "0.75em" }}>
    {children}
  </Box>
);

export default FootnoteSup;
